import { ChevronLeft, ChevronRight, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, ButtonBase, Paper, useMediaQuery } from '@mui/material';
import { ReactNode, useEffect, useRef, useState } from 'react';

import Map, { TMapRef } from './map';

interface IProps {
  children: ReactNode;
}

function Content({ children }: IProps): React.JSX.Element {
  const [containerShowed, showContainer] = useState(true);
  const mapRef = useRef<TMapRef | null>(null);
  const smallDevice = useMediaQuery('(max-width:999px)');

  useEffect(() => {
    setTimeout(() => mapRef.current?.resize(), 200);
  }, [containerShowed]);

  useEffect(() => {
    setTimeout(() => mapRef.current?.resize(), 100);
  }, [smallDevice]);

  return (
    <Box
      alignItems="stretch"
      display="flex"
      flexDirection={smallDevice ? 'column-reverse' : 'row'}
      flexGrow={1}
      overflow="hidden"
    >
      <Paper
        className={[smallDevice ? 'full-width' : ''].join(' ')}
        sx={{
          borderRadius: 0,
          flexShrink: 0,
          maxWidth: '100%',
          overflowX: 'hidden',
          transition: 'width 100ms',
          width: 500,
          zIndex: 2,
          ...(containerShowed ? {} : { width: 0 }),
          ...(smallDevice
            ? { height: containerShowed ? '50%' : 0, transition: 'height 100ms', width: '100%' }
            : {}),
        }}
      >
        {children}
      </Paper>
      <Map flexGrow={1} flexShrink={0} position="relative" ref={mapRef}>
        {smallDevice ? (
          <ButtonBase
            onClick={() => showContainer(!containerShowed)}
            sx={{
              backgroundColor: 'white',
              boxShadow:
                '0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0px rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%)',
              left: 0,
              position: 'absolute',
              borderRadius: '0 4px 0 0',
              bottom: 0,
              zIndex: 2,
            }}
          >
            {containerShowed ? <ExpandMore /> : <ExpandLess />}
          </ButtonBase>
        ) : (
          <ButtonBase
            onClick={() => showContainer(!containerShowed)}
            sx={{
              backgroundColor: 'white',
              boxShadow:
                '0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0px rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%)',
              left: 0,
              position: 'absolute',
              borderRadius: '0 0 4px 0',
              top: 0,
              zIndex: 2,
            }}
          >
            {containerShowed ? <ChevronLeft /> : <ChevronRight />}
          </ButtonBase>
        )}
      </Map>
    </Box>
  );
}

export default Content;
